import { atom, useAtom } from 'jotai';
import { ElevesView } from '@teetsh/app/src/types/eleves';

interface Payload {
  view?: ElevesView;
}

export const renameEleveViewModalPayload = atom<Payload | undefined>(undefined);

export function useRenameViewModal() {
  const [modalPayload, setModalPayload] = useAtom(renameEleveViewModalPayload);
  return {
    isOpen: !!modalPayload,
    openRenameViewModal: (v: ElevesView) => {
      setModalPayload({
        view: v,
      });
    },
    closeModal: () => setModalPayload(undefined),
    payload: modalPayload,
  };
}
